import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserTie, FaHardHat, FaArrowRight } from 'react-icons/fa';
import './ReadyToBuildCta.css';

const ReadyToBuildCta = () => {
  const navigate = useNavigate();

  return (
    <section className="rtb-section">
      <div className="bs-container">
        
        <div className="rtb-header">
          <h2>Ready to Build <span className="bs-text-gold-gradient">Smarter, Not Harder?</span></h2>
          <p>Select your role below to access the tools you need.</p>
        </div>

        <div className="rtb-grid">
          
          {/* OPTION 1: GOLD SHINE BACKGROUND */}
          <div 
            className="rtb-card bg-light-grey" 
            onClick={() => navigate('/select-role')} 
          >
            <div className="rtb-icon-circle blue">
              <FaUserTie />
            </div>
            <div className="rtb-card-content">
              <h3>I'm a Developer / Homeowner</h3>
              <p>I need to find a verified A-Team for my project.</p>
              <button className="rtb-fake-btn blue-btn">
                Find My A-Team <FaArrowRight />
              </button>
            </div>
          </div>

          {/* OPTION 2: LIGHT GREY BACKGROUND */}
          <div 
            className="rtb-card bg-light-grey" 
            onClick={() => navigate('/select-role')} 
          >
            <div className="rtb-icon-circle blue">
              <FaHardHat />
            </div>
            <div className="rtb-card-content">
              <h3>I'm a Consultant / Tradie</h3>
              <p>I want to list my business and find local jobs.</p>
              <button className="rtb-fake-btn blue-btn">
                List My Business <FaArrowRight />
              </button>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ReadyToBuildCta;